import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { languages } from "../../constants/languages";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { groupBy } from "../../util/GroupBy";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import moment from "moment-timezone";
import Switch from "@material-ui/core/Switch";
import { checkRefereeWishLocation } from "../../util/CheckRefereeWishLocation";
import { checkRefereeWishDay } from "../../util/CheckRefereeWishDay";
import { checkRefereeWishMaxMatches } from "../../util/CheckRefereeWishMaxMatches";
import { getMatchDuration } from "../../util/GetMatchDuration";
import DefaultMatchTimes from "../../constants/DefaultMatchTimes";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import DefaultFases from "../../constants/DefaultFases";

class DivideRefereesContainer extends Component {
  state = {
    open: false,
    errorMessage: "",
    overwrite: false,
    notAllPlannedMessage: "",
    loading: false,
  };

  handleOverwriteSwitch = (event, checked) => {
    let newState = {};
    newState[event.target.name] = checked;
    this.setState(newState);
  };

  selectInitialReferees = () => {
    let selectedReferees = [];

    this.props.referees
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        } else {
          return 1;
        }
      })
      .forEach((referee) => {
        let locationWish = checkRefereeWishLocation(
          referee,
          this.props.selectedSportPark
        );
        let dayWish = checkRefereeWishDay(referee, this.props.selectedDay);
        // let numMatches = this.props.matches.filter(
        //   m =>
        //     m.referee === referee.id ||
        //     m.referee2 === referee.id ||
        //     m.referee3 === referee.id
        // ).length;

        // let maxMatchesWish = checkRefereeWishMaxMatches(referee, numMatches);

        let wish = true;

        if (!locationWish) {
          wish = false;
        }

        if (!dayWish) {
          wish = false;
        }

        // if (!maxMatchesWish) {
        //   wish = false;
        // }
        if (wish) {
          selectedReferees.push(referee.id);
        }
      });

    return selectedReferees;
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open, errorMessage: "" });
  };

  checkOverlap = (
    matchStartTime,
    matchEndTime,
    t,
    add24,
    originalMatchEndTime
  ) => {
    let start = t[0];
    let end = t[1];
    if (end < start) {
      // add 24 hours
      let timeSplitted = end.split(":");
      let hours = Number(timeSplitted[0] + 24).toString();
      if (matchStartTime < end) {
        // add 24 hours
        let timeSplittedEnd = matchEndTime.split(":");
        let hoursEnd = Number(timeSplittedEnd[0] + 24).toString();
        matchEndTime = hoursEnd + ":" + timeSplittedEnd[1];

        let timeSplittedStart = matchStartTime.split(":");
        let hoursStart = Number(timeSplittedStart[0] + 24).toString();
        matchStartTime = hoursStart + ":" + timeSplittedStart[1];
      }
      end = hours + ":" + timeSplitted[1];
    } else if (add24 && start < originalMatchEndTime) {
      // add 24 hours
      let timeSplitted = end.split(":");
      let hours = Number(timeSplitted[0] + 24).toString();
      end = hours + ":" + timeSplitted[1];

      let timeSplittedStart = start.split(":");
      let hoursStart = Number(timeSplittedStart[0] + 24).toString();
      start = hoursStart + ":" + timeSplittedStart[1];
    }
    return (
      (start < matchEndTime && start >= matchStartTime) ||
      (end > matchStartTime && end <= matchEndTime) ||
      (start <= matchStartTime && end >= matchEndTime)
    );
  };

  divideReferees = () => {
    this.setState({ loading: true });
    if (this.state.open) {
      this.toggleDialog();
    }

    let numRefereesPerMatch = this.props.tournament.numRefereesPerMatch || "1";
    let refereeKeysToPlan = ["referee"];
    if (
      numRefereesPerMatch === "2" ||
      numRefereesPerMatch === "3" ||
      numRefereesPerMatch === "4" ||
      numRefereesPerMatch === "5"
    ) {
      refereeKeysToPlan.push("referee2");
    }
    if (
      numRefereesPerMatch === "3" ||
      numRefereesPerMatch === "4" ||
      numRefereesPerMatch === "5"
    ) {
      refereeKeysToPlan.push("referee3");
    }
    if (numRefereesPerMatch === "4" || numRefereesPerMatch === "5") {
      refereeKeysToPlan.push("referee4");
    }
    if (numRefereesPerMatch === "5") {
      refereeKeysToPlan.push("referee5");
    }
    let numMatchesPerReferee = {};
    this.props.referees.forEach((referee) => {
      let numMatches = this.props.matches.filter(
        (m) =>
          m.referee === referee.id ||
          m.referee2 === referee.id ||
          m.referee3 === referee.id ||
          m.referee4 === referee.id ||
          m.referee5 === referee.id
      ).length;

      numMatchesPerReferee[referee.id] = numMatches;
    });

    let selectedReferees = this.selectInitialReferees();
    let fieldsForSelectedLocation = Object.keys(
      this.props.tournament.fields || {}
    ).filter((key) => {
      let field = this.props.tournament.fields[key];
      let showField = false;
      if (this.props.selectedSportPark === "0") {
        if (field.sportPark === undefined || field.sportPark === "0") {
          showField = true;
        }
      } else {
        if (field.sportPark === this.props.selectedSportPark) {
          showField = true;
        }
      }
      return showField;
    });
    let breaks = Object.keys(this.props.tournament.breaks || {}).map(
      (key, i) => {
        let tournamentBreak = this.props.tournament.breaks[key];
        tournamentBreak["id"] = key;
        tournamentBreak["isBreak"] = true;
        return tournamentBreak;
      }
    );

    let matchesPerField = groupBy(
      this.props.matches
        .concat(breaks)
        .filter(
          (match) =>
            match.field !== null &&
            fieldsForSelectedLocation.indexOf(match.field) !== -1
        ),
      "field"
    );
    let matchesPerRound = {};
    let dividedRefs = {};
    let refPrefNot = {};
    let divisionStartTimes = {};
    let divisionEndTimes = {};
    let teamIdsDividedAtLocation = [];
    for (let i in Object.keys(matchesPerField)) {
      let matches = matchesPerField[Object.keys(matchesPerField)[i]]
        .filter((m) => m.day === this.props.selectedDay)
        .sort((a, b) => {
          if (Number(a.numInField) > Number(b.numInField)) {
            return 1;
          } else if (Number(a.numInField) < Number(b.numInField)) {
            return -1;
          } else {
            return 0;
          }
        });

      let field = (this.props.tournament.fields || {})[
        Object.keys(matchesPerField)[i]
      ];
      let startTimestamp = field.startTime;
      if (this.props.selectedDay !== "0") {
        startTimestamp = field[this.props.selectedDay] || field.startTime;
      }
      for (let m in matches) {
        let match = matches[m];

        const matchDuration = getMatchDuration(
          this.props.tournament,
          this.props.poulesByKey,
          match
        );

        const startTime = moment.unix(startTimestamp).format("HH:mm");
        const endTime = moment
          .unix(startTimestamp + matchDuration * 60)
          .format("HH:mm");

        // used for preferences
        let startTimeBeforePref = moment
          .unix(
            startTimestamp -
              (matchDuration * 60 +
                (this.props.tournament.timeBetweenMatches !== undefined
                  ? this.props.tournament.timeBetweenMatches
                  : DefaultMatchTimes.timeBetweenMatches) *
                  60)
          )
          .format("HH:mm");
        let endTimeBeforePref = startTime;

        let startTimeAfterPref = moment
          .unix(startTimestamp + matchDuration * 60)
          .format("HH:mm");
        let endTimeAfterPref = moment
          .unix(
            startTimestamp +
              matchDuration * 60 +
              matchDuration * 60 +
              (this.props.tournament.timeBetweenMatches !== undefined
                ? this.props.tournament.timeBetweenMatches
                : DefaultMatchTimes.timeBetweenMatches) *
                60 +
              (this.props.tournament.timeBetweenMatches !== undefined
                ? this.props.tournament.timeBetweenMatches
                : DefaultMatchTimes.timeBetweenMatches) *
                60
          )
          .format("HH:mm");
        //

        let matchWithTime = match;
        if (match.isBreak) {
          startTimestamp += Number(match.duration || 0) * 60;
          if (match.isEvent) {
            (match.teams || []).forEach((t) => {
              if (this.props.tournament.teamsAsRefs) {
                if (this.props.refereesByKey[t] !== undefined) {
                  if (dividedRefs[t] === undefined) {
                    dividedRefs[t] = [];
                  }
                  dividedRefs[t].push([startTime, endTime]);
                }
              }
            });
          }
        } else {
          startTimestamp += matchDuration * 60;
          startTimestamp +=
            (this.props.tournament.timeBetweenMatches !== undefined
              ? this.props.tournament.timeBetweenMatches
              : DefaultMatchTimes.timeBetweenMatches) * 60;

          const poule = this.props.poulesByKey[match.poule] || {};
          let pouleKeyName = poule.fase;
          if (poule.bracket) {
            let bracket = this.props.bracketsByKey[poule.bracket] || {};
            pouleKeyName =
              poule.bracketRound === bracket.size && !bracket.subBracketTo
                ? poule.fase
                : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
          }
          let team1 = this.props.teams.find(
            (t) =>
              t["poule" + pouleKeyName] === match.poule &&
              t["numInPoule" + pouleKeyName] === match.team1
          );
          let team2 = this.props.teams.find(
            (t) =>
              t["poule" + pouleKeyName] === match.poule &&
              t["numInPoule" + pouleKeyName] === match.team2
          );
          if (team1) {
            matchWithTime["team1Id"] = team1.id;

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.refereesByKey[team1.id] !== undefined) {
                if (dividedRefs[team1.id] === undefined) {
                  dividedRefs[team1.id] = [];
                }
                dividedRefs[team1.id].push([startTime, endTime]);

                if (refPrefNot[team1.id] === undefined) {
                  refPrefNot[team1.id] = [];
                }
                refPrefNot[team1.id].push([
                  startTimeBeforePref,
                  endTimeBeforePref,
                  match.field,
                ]);
                refPrefNot[team1.id].push([
                  startTimeAfterPref,
                  endTimeAfterPref,
                  match.field,
                ]);
              }
              teamIdsDividedAtLocation.push(team1.id);
            }
          }
          if (team2) {
            matchWithTime["team2Id"] = team2.id;

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.refereesByKey[team2.id] !== undefined) {
                if (dividedRefs[team2.id] === undefined) {
                  dividedRefs[team2.id] = [];
                }
                dividedRefs[team2.id].push([startTime, endTime]);

                if (refPrefNot[team2.id] === undefined) {
                  refPrefNot[team2.id] = [];
                }
                refPrefNot[team2.id].push([
                  startTimeBeforePref,
                  endTimeBeforePref,
                  match.field,
                ]);
                refPrefNot[team2.id].push([
                  startTimeAfterPref,
                  endTimeAfterPref,
                  match.field,
                ]);
              }
              teamIdsDividedAtLocation.push(team2.id);
            }
          }

          if (match.referee && !this.state.overwrite) {
            if (dividedRefs[match.referee] === undefined) {
              dividedRefs[match.referee] = [];
            }
            dividedRefs[match.referee].push([startTime, endTime]);
          }
          if (match.referee && this.state.overwrite) {
            if (numMatchesPerReferee[match.referee]) {
              numMatchesPerReferee[match.referee]--;
            }
          }
          if (match.referee2 && !this.state.overwrite) {
            if (dividedRefs[match.referee2] === undefined) {
              dividedRefs[match.referee2] = [];
            }
            dividedRefs[match.referee2].push([startTime, endTime]);
          }
          if (match.referee2 && this.state.overwrite) {
            if (numMatchesPerReferee[match.referee2]) {
              numMatchesPerReferee[match.referee2]--;
            }
          }
          if (match.referee3 && !this.state.overwrite) {
            if (dividedRefs[match.referee3] === undefined) {
              dividedRefs[match.referee3] = [];
            }
            dividedRefs[match.referee3].push([startTime, endTime]);
          }
          if (match.referee3 && this.state.overwrite) {
            if (numMatchesPerReferee[match.referee3]) {
              numMatchesPerReferee[match.referee3]--;
            }
          }
          if (match.referee4 && !this.state.overwrite) {
            if (dividedRefs[match.referee4] === undefined) {
              dividedRefs[match.referee4] = [];
            }
            dividedRefs[match.referee4].push([startTime, endTime]);
          }
          if (match.referee4 && this.state.overwrite) {
            if (numMatchesPerReferee[match.referee4]) {
              numMatchesPerReferee[match.referee4]--;
            }
          }
          if (match.referee5 && !this.state.overwrite) {
            if (dividedRefs[match.referee5] === undefined) {
              dividedRefs[match.referee5] = [];
            }
            dividedRefs[match.referee5].push([startTime, endTime]);
          }
          if (match.referee5 && this.state.overwrite) {
            if (numMatchesPerReferee[match.referee5]) {
              numMatchesPerReferee[match.referee5]--;
            }
          }

          if (divisionStartTimes[poule.division] === undefined) {
            divisionStartTimes[poule.division] = startTimeBeforePref;
          } else {
            if (startTimeBeforePref < divisionStartTimes[poule.division]) {
              divisionStartTimes[poule.division] = startTimeBeforePref;
            }
          }
          if (divisionEndTimes[poule.division] === undefined) {
            divisionEndTimes[poule.division] = endTimeAfterPref;
          } else {
            if (endTimeAfterPref > divisionEndTimes[poule.division]) {
              divisionEndTimes[poule.division] = endTimeAfterPref;
            }
          }
        }

        matchWithTime["startTime"] = startTime;
        matchWithTime["endTime"] = endTime;

        if (!match.isBreak) {
          if (matchesPerRound[m] === undefined) {
            matchesPerRound[m] = [];
          }
          matchesPerRound[m].push(matchWithTime);
        }
      }
    }
    const db = window.firebase.firestore();
    let batch = db.batch();
    let numInBatch = 0;
    const batches = [];
    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");

    let referees = this.props.referees
      .filter((r) => selectedReferees.indexOf(r.id) !== -1)
      .sort((a, b) => {
        let numMatchesA = numMatchesPerReferee[a.id] || 0;
        let numMatchesB = numMatchesPerReferee[b.id] || 0;
        if (numMatchesA < numMatchesB) {
          return -1;
        } else if (numMatchesA > numMatchesB) {
          return 1;
        } else {
          function chunkify(t) {
            var tz = [],
              x = 0,
              y = -1,
              n = 0,
              i,
              j;

            while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
              // eslint-disable-next-line
              var m = i == 46 || (i >= 48 && i <= 57);
              if (m !== n) {
                tz[++y] = "";
                n = m;
              }
              tz[y] += j;
            }
            return tz;
          }

          let toChunkA = a["name"] || "";
          let toChunkB = b["name"] || "";

          var aa = chunkify(toChunkA.toString().toLowerCase());
          var bb = chunkify(toChunkB.toString().toLowerCase());

          for (let x = 0; aa[x] && bb[x]; x++) {
            if (aa[x] !== bb[x]) {
              var c = Number(aa[x]),
                d = Number(bb[x]);
              // eslint-disable-next-line
              if (c == aa[x] && d == bb[x]) {
                return c - d;
              } else return aa[x] > bb[x] ? 1 : -1;
            }
          }
          return aa.length - bb.length;
        }
      });

    let notAllMatchesPlanned = false;
    // let refereesPerRound = {};
    for (let i in Object.keys(matchesPerRound)) {
      // refereesPerRound[i] = [];
      let matches = matchesPerRound[Object.keys(matchesPerRound)[i]];
      for (let m in matches) {
        let match = matches[m];
        let poule = this.props.poulesByKey[match.poule] || {};
        let division = this.props.divisionsObject[poule.division] || {};
        let matchStartTime = match.startTime;
        let matchEndTime = match.endTime;
        let add24 = false;
        if (matchEndTime < matchStartTime) {
          // add 24 hours
          let timeSplitted = matchEndTime.split(":");
          let hours = Number(timeSplitted[0] + 24).toString();
          matchEndTime = hours + ":" + timeSplitted[1];
          add24 = true;
        }
        let toUpdate = {};
        if (this.state.overwrite) {
          toUpdate = {
            referee: "",
            referee2: "",
            referee3: "",
            referee4: "",
            referee5: "",
          };
        }
        let foundReferee = true;
        refereeKeysToPlan.forEach((key) => {
          if (!match[key] || this.state.overwrite) {
            foundReferee = false;
            toUpdate[key] = "";
            let refereesForSecondTry = [];
            for (let r in referees) {
              let referee = referees[r];
              let validTime = true;
              let times = dividedRefs[referee.id] || [];

              let overlapRef = times.filter((t) => {
                return this.checkOverlap(
                  matchStartTime,
                  matchEndTime,
                  t,
                  add24,
                  match.endTime
                );
              });
              if (overlapRef.length > 0) {
                validTime = false;
              }

              let maxMatchesWish = checkRefereeWishMaxMatches(
                referee,
                numMatchesPerReferee[referee.id] || 0
              );

              let roles = referee.roles || "all";
              let roleToCheck = "0";
              if (key === "referee2") {
                roleToCheck = "1";
              }
              if (key === "referee3") {
                roleToCheck = "2";
              }
              if (key === "referee4") {
                roleToCheck = "3";
              }
              if (key === "referee5") {
                roleToCheck = "4";
              }

              let roleWish =
                roles === "all" || roles.indexOf(roleToCheck) !== -1;

              let divisions = referee.divisionsReferee || "all";

              let divisionWish =
                divisions === "all" || divisions.indexOf(poule.division) !== -1;

              let fieldWish = true;
              fieldWish = checkRefereeWishLocation(
                referee,
                this.props.selectedSportPark,
                match.field
              );

              let timeWish = true;

              timeWish = checkRefereeWishDay(
                referee,
                this.props.selectedDay,
                match.startTime,
                match.endTime
              );

              let teamWish =
                (referee.excludeTeams || []).indexOf(match.team1Id) === -1 &&
                (referee.excludeTeams || []).indexOf(match.team2Id) === -1;

              let teamWish2 = true;
              (referee.excludeTeams || []).forEach((tId) => {
                if (!(this.props.teamsByKey[tId] || {}).poule0) {
                  teamWish2 = false;
                }
              });

              let phaseRequirement = true;
              if (
                poule.fase > 0 &&
                !((division.fases || DefaultFases)[poule.fase] || {}).started &&
                (referee.excludeTeams || []).length > 0
              ) {
                phaseRequirement = false;
              }

              let duringDivisionTimes = true;
              if (referee.teamId) {
                let team = this.props.teamsByKey[referee.teamId];
                if (
                  team &&
                  divisionStartTimes[team.division] &&
                  divisionEndTimes[team.division]
                ) {
                  if (match.startTime < divisionStartTimes[team.division]) {
                    duringDivisionTimes = false;
                  }
                  if (match.endTime > divisionEndTimes[team.division]) {
                    duringDivisionTimes = false;
                  }
                }
              }

              let teamPlaysAtLocation = true;
              if (this.props.tournament.teamsAsRefs && referee.teamId) {
                if (teamIdsDividedAtLocation.indexOf(referee.teamId) === -1) {
                  teamPlaysAtLocation = false;
                }
              }

              let refPref = true;
              // check preference
              if (refPrefNot[referee.id]) {
                let overlapRefPref = refPrefNot[referee.id].filter((t) => {
                  return (
                    this.checkOverlap(
                      matchStartTime,
                      matchEndTime,
                      t,
                      add24,
                      match.endTime
                    ) && t[2] !== match.field
                  );
                });

                if (overlapRefPref.length > 0) {
                  refPref = false;
                }
              }

              let maxMatchesReferee = 0;
              Object.keys(numMatchesPerReferee).forEach((r) => {
                let num = numMatchesPerReferee[r];
                if (num > maxMatchesReferee) {
                  maxMatchesReferee = num;
                }
              });
              let minMatchesReferee = maxMatchesReferee;
              Object.keys(numMatchesPerReferee).forEach((r) => {
                let num = numMatchesPerReferee[r];
                if (num < minMatchesReferee) {
                  minMatchesReferee = num;
                }
              });

              if (
                validTime &&
                maxMatchesWish &&
                roleWish &&
                divisionWish &&
                fieldWish &&
                timeWish &&
                teamWish &&
                teamWish2 &&
                phaseRequirement &&
                duringDivisionTimes &&
                teamPlaysAtLocation
              ) {
                // check preference
                if (
                  !refPref &&
                  !(
                    maxMatchesReferee -
                      (numMatchesPerReferee[referee.id] || 0) >
                    1
                  )
                ) {
                  refereesForSecondTry.push(referee);
                } else if (
                  (numMatchesPerReferee[referee.id] || 0) - minMatchesReferee >
                  0
                ) {
                  refereesForSecondTry.push(referee);
                } else {
                  // valid referee
                  toUpdate[key] = referee.id;
                  // refereesPerRound[i].push(referee.id);
                  referees.splice(r, 1);
                  referees.push(referee);
                  if (dividedRefs[referee.id] === undefined) {
                    dividedRefs[referee.id] = [];
                  }
                  dividedRefs[referee.id].push([
                    match.startTime,
                    match.endTime,
                  ]);
                  numMatchesPerReferee[referee.id]++;

                  foundReferee = true;
                  break;
                }
              }
            }
            if (!foundReferee && refereesForSecondTry.length > 0) {
              let referee = refereesForSecondTry.sort((a, b) => {
                let numMatchesA = numMatchesPerReferee[a.id] || 0;
                let numMatchesB = numMatchesPerReferee[b.id] || 0;
                if (numMatchesA < numMatchesB) {
                  return -1;
                } else if (numMatchesA > numMatchesB) {
                  return 1;
                } else {
                  return 0;
                }
              })[0];

              // valid referee
              toUpdate[key] = referee.id;
              let refereeIndex = referees.findIndex((r) => r.id === referee.id);
              referees.splice(refereeIndex, 1);
              referees.push(referee);
              if (dividedRefs[referee.id] === undefined) {
                dividedRefs[referee.id] = [];
              }
              dividedRefs[referee.id].push([match.startTime, match.endTime]);
              numMatchesPerReferee[referee.id]++;

              foundReferee = true;
            }
          }
        });
        if (!foundReferee) {
          notAllMatchesPlanned = true;
        }
        batch.update(matchesRef.doc(match.id), toUpdate);
        numInBatch++;
        if (numInBatch > 499) {
          numInBatch = 0;
          batches.push(batch);
          batch = db.batch();
        }
      }
    }
    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
      numInBatch++;
    }
    if (numInBatch > 0) {
      batches.push(batch);
    }
    Promise.all(batches.map((b) => b.commit())).then(() => {
      let newState = { overwrite: false, loading: false };
      if (notAllMatchesPlanned) {
        newState["notAllPlannedMessage"] = languages.formatString(
          languages.referees.notAllMatchesPlanned,
          this.props.tournament.numRefereesPerMatch || "1",
          this.props.tournament.individualPlayers
            ? languages.teams.playersLow
            : languages.tournament.teamsLow
        );
      }
      this.setState(newState);
    });
  };

  render() {
    let hasRefsAlreadyPlanned = false;

    let fieldsForSelectedLocation = Object.keys(
      this.props.tournament.fields || {}
    ).filter((key) => {
      let field = this.props.tournament.fields[key];
      let showField = false;
      if (this.props.selectedSportPark === "0") {
        if (field.sportPark === undefined || field.sportPark === "0") {
          showField = true;
        }
      } else {
        if (field.sportPark === this.props.selectedSportPark) {
          showField = true;
        }
      }
      return showField;
    });
    this.props.matches
      .filter(
        (match) =>
          match.field !== null &&
          fieldsForSelectedLocation.indexOf(match.field) !== -1 &&
          match.day === this.props.selectedDay
      )
      .forEach((m) => {
        let match = m;

        if (hasRefsAlreadyPlanned === false) {
          if (
            match.referee ||
            match.referee2 ||
            match.referee3 ||
            match.referee4 ||
            match.referee5
          ) {
            hasRefsAlreadyPlanned = true;
          }
        }
      });
    return (
      <div>
        <Button
          fullWidth
          size="small"
          variant="outlined"
          color="default"
          onClick={() => {
            this.selectInitialReferees();
            if (hasRefsAlreadyPlanned) {
              this.toggleDialog();
            } else {
              this.divideReferees();
            }
          }}
          style={{ marginTop: 10 }}
          disabled={this.props.tournament.scheduleLocked || false}
        >
          {languages.referees.divide +
            " " +
            languages.schedule.on +
            " " +
            moment
              .unix(
                this.props.selectedDay === "0"
                  ? this.props.tournament.date
                  : (this.props.daysByKey[this.props.selectedDay] || {}).date
              )
              .format(languages.createTournament.dateFormat)}
        </Button>
        <Dialog
          open={this.state.open || this.state.notAllPlannedMessage.length > 0}
          onClose={this.toggleDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {languages.referees.divideReferees}
          </DialogTitle>
          <DialogContent style={{ width: 700, maxWidth: "97%" }}>
            {hasRefsAlreadyPlanned &&
              !this.state.notAllPlannedMessage &&
              this.state.open && (
                <FormControlLabel
                  style={{ marginBottom: 15 }}
                  control={
                    <Switch
                      checked={this.state.overwrite}
                      onChange={this.handleOverwriteSwitch}
                      color="primary"
                      name="overwrite"
                    />
                  }
                  label={languages.referees.overwriteDescription}
                />
              )}

            {(this.state.errorMessage || "").length > 0 && (
              <DialogContentText style={{ color: "red" }}>
                {this.state.errorMessage}
              </DialogContentText>
            )}
            {this.state.notAllPlannedMessage && (
              <DialogContentText>
                {this.state.notAllPlannedMessage}
              </DialogContentText>
            )}
            <br />
          </DialogContent>
          {this.state.notAllPlannedMessage ? (
            <DialogActions>
              <Button
                onClick={() => {
                  this.setState({ notAllPlannedMessage: "" });
                }}
                color="primary"
              >
                {languages.general.close}
              </Button>
            </DialogActions>
          ) : (
            <DialogActions>
              <Button onClick={this.toggleDialog} color="primary">
                {languages.general.cancel}
              </Button>
              <Button
                onClick={this.divideReferees}
                variant="contained"
                color="primary"
              >
                {languages.referees.divide}
              </Button>
            </DialogActions>
          )}
        </Dialog>
        <Backdrop
          // className={classes.backdrop}
          style={{ zIndex: 9999, color: "#fff" }}
          open={this.state.loading}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    );
  }
}

export default DivideRefereesContainer;
